// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.paleGrey {
  color: #ccc;
}

.cardHeaderMainTitle {
  font-family: MontserratSemiBold, sans-serif;
  padding-top: 13px;
}

.cardHeader {
  width: auto;
  background-color: rgb(206, 206, 206);
  border-bottom: 2px solid #999;
  padding: 4px 4px 4px 10px;
  height: 50px;
}

.main-container {
  padding: 10px;
  overflow-y: auto;
  width: 100%;
  height: -moz-fit-content;
  height: fit-content;
  background-color: white;
  border-left: 2px solid rgb(206, 206, 206);
  border-right: 2px solid rgb(206, 206, 206);
  border-bottom: 2px solid rgb(206, 206, 206);
}

.main-container-truncate {
  border: none;
}

.card-footer {
  width: auto;
  padding: 4px 4px 4px 0;
  height: 25px;
}

.orangeLink {
  text-decoration: none;
  color: #5BC8AC;
  font-weight: bolder;
}

.cover {
  position: absolute;
  z-index: 1000;
  background-color: rgba(255, 255, 255, 0.775);
  top: 0;
  bottom: 20px;
  width: 100%;
}

.coverBottom {
  position: absolute;
  z-index: 1000;
  background-color: rgba(255, 255, 255, 0.775);
  height: 35px !important;
  bottom: -10px;
  width: 100%;
}

.sendPcr {
  font-family: MontserratSemiBold, sans-serif;
  width: 100%;
  margin: 60px auto auto auto;
  text-align: center;
  text-decoration: underline;
  cursor: pointer;
}

.emailIcon {
  font-size: 15px;
  width: 18px;
  height: 0;
  padding-top: 1px;
}

.buttons {
  width: 100%;
}

.button {
  margin-top: 10px;
  padding: 5px;
  color: white;
  width: calc(50% - 5px);
  text-align: center;
  background: #666;
  cursor: pointer;
}

.button:hover {
  background: #777;
  cursor: pointer;
}

.redButton {
  background: #F07B7E;
}

.redButton:hover {
  background: #ef9799;
}

.listDisplay {
  height: 213.5px;
}

.smallMobile {
  height: 175px;
}

.bufferTruncate {
  padding-top: 5px;
}`, "",{"version":3,"sources":["webpack://./src/app/analysis/jobSatisfactions/components/commonClasses/job-satisfactions-person-card/sub-card/job-satisfactions-person-sub-card-personality/job-satisfactions-person-sub-card-personality.component.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;AACJ;;AAEA;EACI,2CAAA;EACA,iBAAA;AACJ;;AAEA;EACI,WAAA;EACA,oCAAA;EACA,6BAAA;EACA,yBAAA;EACA,YAAA;AACJ;;AAEA;EACI,aAAA;EACA,gBAAA;EACA,WAAA;EACA,wBAAA;EAAA,mBAAA;EACA,uBAAA;EACA,yCAAA;EACA,0CAAA;EACA,2CAAA;AACJ;;AAEA;EACI,YAAA;AACJ;;AAEA;EACI,WAAA;EACA,sBAAA;EACA,YAAA;AACJ;;AAEA;EACI,qBAAA;EACA,cAAA;EACA,mBAAA;AACJ;;AAEA;EACI,kBAAA;EACA,aAAA;EACA,4CAAA;EACA,MAAA;EACA,YAAA;EACA,WAAA;AACJ;;AAGA;EACI,kBAAA;EACA,aAAA;EACA,4CAAA;EACA,uBAAA;EACA,aAAA;EACA,WAAA;AAAJ;;AAGA;EACI,2CAAA;EACA,WAAA;EACA,2BAAA;EACA,kBAAA;EACA,0BAAA;EACA,eAAA;AAAJ;;AAGA;EACI,eAAA;EACA,WAAA;EACA,SAAA;EACA,gBAAA;AAAJ;;AAGA;EACI,WAAA;AAAJ;;AAGA;EACI,gBAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AAAJ;;AAGA;EACI,gBAAA;EACA,eAAA;AAAJ;;AAGA;EACI,mBAAA;AAAJ;;AAGA;EACI,mBAAA;AAAJ;;AAGA;EACI,eAAA;AAAJ;;AAGA;EACI,aAAA;AAAJ;;AAGA;EACI,gBAAA;AAAJ","sourcesContent":[".paleGrey {\n    color: #ccc;\n}\n\n.cardHeaderMainTitle {\n    font-family: MontserratSemiBold,  sans-serif;\n    padding-top: 13px;\n}\n\n.cardHeader {\n    width: auto;\n    background-color: rgb(206, 206, 206);\n    border-bottom: 2px solid #999;\n    padding: 4px 4px 4px 10px;\n    height: 50px;\n}\n\n.main-container {\n    padding: 10px;\n    overflow-y: auto;\n    width: 100%;\n    height: fit-content;\n    background-color: white;\n    border-left: 2px solid rgb(206, 206, 206);\n    border-right: 2px solid rgb(206, 206, 206);\n    border-bottom: 2px solid rgb(206, 206, 206);\n}\n\n.main-container-truncate {\n    border: none;\n}\n\n.card-footer {\n    width: auto;\n    padding: 4px 4px 4px 0;\n    height: 25px;\n}\n\n.orangeLink {\n    text-decoration: none;\n    color: #5BC8AC;\n    font-weight: bolder;\n}\n\n.cover {\n    position: absolute;\n    z-index: 1000;\n    background-color: rgba(255, 255, 255, .775);\n    top: 0;\n    bottom: 20px;\n    width: 100%;\n\n}\n\n.coverBottom {\n    position: absolute;\n    z-index: 1000;\n    background-color: rgba(255, 255, 255, 0.775);\n    height: 35px !important;\n    bottom: -10px;\n    width: 100%;\n}\n\n.sendPcr {\n    font-family: MontserratSemiBold,  sans-serif;\n    width: 100%;\n    margin: 60px auto auto auto;\n    text-align: center;\n    text-decoration: underline;\n    cursor: pointer;\n}\n\n.emailIcon {\n    font-size: 15px;\n    width: 18px;\n    height: 0;\n    padding-top: 1px;\n}\n\n.buttons {\n    width: 100%;\n}\n\n.button {\n    margin-top: 10px;\n    padding: 5px;\n    color: white;\n    width: calc(50% - 5px);\n    text-align: center;\n    background: #666;\n    cursor: pointer;\n}\n\n.button:hover {\n    background: #777;\n    cursor: pointer;\n}\n\n.redButton {\n    background: #F07B7E;\n}\n\n.redButton:hover {\n    background: #ef9799;\n}\n\n.listDisplay {\n    height: 213.5px;\n}\n\n.smallMobile {\n    height: 175px;\n}\n\n.bufferTruncate {\n    padding-top: 5px\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
